/**
 * RTK Query endpoints for conversation participant management.
 * Handles adding participants and leaving conversations.
 */

import type {
  AddParticipantRequest,
  ConversationResponse,
} from '../interfaces/conversation.interface'
import { agentsApiSlice } from './agents-api.store'

const API_BASE = '/api/v1/conversations'

const conversationParticipantEndpoints = agentsApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addConversationParticipant: builder.mutation<
      ConversationResponse,
      { conversationId: string; payload: AddParticipantRequest }
    >({
      query: ({ conversationId, payload }) => ({
        url: `${API_BASE}/${conversationId}/participants`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (_, __, { conversationId }) => [
        { type: 'Conversation', id: conversationId },
      ],
    }),

    leaveConversation: builder.mutation<ConversationResponse, string>({
      query: (conversationId) => ({
        url: `${API_BASE}/${conversationId}/leave`,
        method: 'POST',
      }),
      invalidatesTags: (_, __, conversationId) => [
        { type: 'Conversation', id: conversationId },
        'Conversations',
      ],
    }),
  }),
})

export const { useAddConversationParticipantMutation, useLeaveConversationMutation } =
  conversationParticipantEndpoints
